




























































































































































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Approvisionnement} from '@/models';

import storeApprovisionnement from '@/stores/modules/approvisionnement';
import storeFournisseur from '@/stores/modules/fournisseur';

import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
import CrudFournisseurSearch from "@/components/Crud/Fournisseur/Search.vue";
import CrudBoisTypeSearch from "@/components/Crud/BoisType/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputDatePicker from "@/components/Input/DatePicker.vue";
import storeVente from "@/stores/modules/vente";
import storeBoisType from "@/stores/modules/boisType";
import storeLongueursVente from "@/stores/modules/longueursVente";
import storePile from "@/stores/modules/pile";
import storeTransporteur from '@/stores/modules/transporteur';

@Component({
	components: {
		CrudTransporteurSearch,
		CrudFournisseurSearch,
		CrudBoisTypeSearch,
		InputBoisType,
		InputDatePicker,
	}
})
export default class CrudApprovisionnementEdit extends AbstractEditVue<Approvisionnement> {

	// DF: utiliser pour la création d'un approvisionnement uniquement
	// en modification on passe par la light
	private step: number = 1;
	private savedisabled: Boolean = true;
	private checkDivers: Boolean = false;

	private storeFournisseur = storeFournisseur
	private storeTransporteur = storeTransporteur
	private storeBoisType = storeBoisType
	private storeLongueursVente = storeLongueursVente
	private storePile = storePile

	public constructor() {
		super(
			storeApprovisionnement,
			'Approvisionnement modifié',
			'Approvisionnement créé',
		);
	}

	public watcher(): void {
		if (this.item)
		{
			if (!this.item.boisType || !this.item.longueursVente || !this.item.volume)
			{
				this.savedisabled = true;
			}
			else
			{
				this.savedisabled = false;
			}
		}
	}

	public watcherDivers(): void {
		if (this.item.fournisseur) {
			if (this.item.fournisseur.id === 6) {
				this.checkDivers = true;
			} else {
				this.checkDivers = false;
			}
		}
	}

	//	@Emit()
	//	private onNext() {
	//		if ((!this.item.address) || (this.item.address === null) )
	//		{
	//			this.item.address = this.item.name;
	//		}
	//		this.step = 2;
	//	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await storeFournisseur.dispatch('getAll');
		await storeTransporteur.dispatch('getC', {filters: false});
		await storeBoisType.dispatch('getC', {filters: false});
		await storeLongueursVente.dispatch('getAll');
		await storePile.dispatch('getAll');
		await super.mounted();
		await this.watcherDivers();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		this.watcher();
		//console.log('route approvisionnement edit = ' + this.$route.name);
		if (this.$route.name === 'approvisionnement-edit') {
			this.$route.meta.title = 'Modification  d\'un approvisionnement';
		}
	}

}
